<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/toolbox-icon.svg" alt="">
    </div>
    Mantenciones
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Nueva mantención</h2>
    <a routerLink="/maintenances" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <mat-progress-bar mode="indeterminate" *ngIf="showProgressBar"></mat-progress-bar>
    
    <mat-horizontal-stepper linear>
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel>Información</ng-template>          
          <div class="mb-4">
            <label>Selecciona tipo de envase</label>
            <mat-select class="select" placeholder="Selecciona" formControlName="containerType">
              <mat-option *ngFor="let type of containerTypes" [value]="type.id">{{ type.name }}</mat-option>
            </mat-select>
            <div *ngIf="firstFormGroup.get('containerType')?.invalid && firstFormGroup.get('containerType')?.touched" class="text-red-500">
              Tipo de envase es requerido.
            </div>
          </div>
          
          <div class="mb-4">
            <label>Selecciona tipo de mantención</label>
            <mat-select class="select" placeholder="Selecciona" formControlName="maintenanceType">
              <mat-option *ngFor="let type of maintenanceTypes" [value]="type.id">{{ type.name }}</mat-option>
            </mat-select>
            <div *ngIf="firstFormGroup.get('maintenanceType')?.invalid && firstFormGroup.get('maintenanceType')?.touched" class="text-red-500">
              Tipo de mantención es requerido.
            </div>
          </div>
          
          <div class="mb-4">
            <label>Selecciona un rol</label>
            <mat-select class="select" placeholder="Selecciona" formControlName="role">
              <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.roleName }}</mat-option>
            </mat-select>
            <div *ngIf="firstFormGroup.get('role')?.invalid && firstFormGroup.get('role')?.touched" class="text-red-500">
              Rol es requerido.
            </div>
          </div>


          <div class="mb-4">
            <label>Selecciona un rol aprobador</label>
            <mat-select class="select" placeholder="Selecciona" formControlName="rolApprover">
              <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.roleName }}</mat-option>
            </mat-select>
            <div *ngIf="firstFormGroup.get('role')?.invalid && firstFormGroup.get('role')?.touched" class="text-red-500">
              Rol es requerido.
            </div>
          </div>
          
          <div class="mb-4">
            <label>Selecciona el estado</label>
            <mat-select class="select" placeholder="Selecciona" formControlName="status">
              <mat-option *ngFor="let status of statuses" [value]="status.value">{{ status.viewValue }}</mat-option>
            </mat-select>
            <div *ngIf="firstFormGroup.get('status')?.invalid && firstFormGroup.get('status')?.touched" class="text-red-500">
              Estado es requerido.
            </div>
          </div>
          
          <div class="flex justify-center mt-4">
            <button matStepperPrevious class="button button-outlined-primary">
              <i class="fas fa-chevron-left" aria-hidden="true"></i> Volver
            </button>
            <button matStepperNext class="button button-primary">
              Continuar <i class="fas fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup">
        <form [formGroup]="secondFormGroup">
          <ng-template matStepLabel>Define las etapas</ng-template>
          <!--<button mat-button (click)="addStageAccordion()">Agregar Etapa</button>-->
          <div formArrayName="stages">
            <div *ngFor="let stage of getStageFormArray().controls; let i = index" [formGroupName]="i">
              <app-stage-create [index]="i" [formGroup]="getFormGroup(stage)" [tasks]="tasks" [acceptanceCriterias]="acceptanceCriterias" [isMaintenanceUpdate]="false" (remove)="removeStage(i)"></app-stage-create>
            </div>
          </div>
          <div class="flex justify-end">
            <button class="button button-primary button-sm" (click)="addStageAccordion()">Agregar Etapa</button>
          </div>
          <div *ngIf="errorMessage" class="mb-4 text-red-500">
            {{ errorMessage }}
          </div>
          <div class="flex justify-center mt-4">
            <button class="button button-outlined-primary" matStepperPrevious>
              <i class="fas fa-chevron-left" aria-hidden="true"></i> Volver
            </button>
            <button class="button button-success" (click)="onSubmit()">Guardar</button>
          </div>
        </form>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
